module.exports = __webpack_public_path__ + "static/sudhanshu-377cf556dc568642489dc0e6102f611d.png";